import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

type Props = {
    id: string;
    children: JSX.Element;
    isDisabled: boolean;
};

function ShiftDraggable({ id, children, isDisabled }: Readonly<Props>) {
    const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
        id: id,
        data: { children },
        disabled: isDisabled
    });

    const style = transform ? {
        transform: CSS.Translate.toString(transform),
        zIndex: isDragging ? 1442 : 'auto',
        position: isDragging ? 'relative' : 'static',
        cursor:  isDragging ? 'grabbing' : 'grab',
        padding: '2.5px 5px',
        border: '1px dashed hsl(from var(--primary-color) h s calc(l + 5))',
        background: 'hsl(from var(--primary-color) h s calc(l + 35))',
        boxShadow: 'var(--bs-box-shadow-lg)',
        borderRadius: '3px',
        userSelect: 'none',
        touchAction: 'none',
        width: '100%',
    } : {
        cursor: 'grab',
        touchAction: 'none',
        width: '100%',
    };

    return (
        <div
            ref={setNodeRef}
            style={style as any}
            {...listeners}
            {...attributes}
        >
            <span style={isDragging ? { pointerEvents: 'none' } : {}}>
                {children}
            </span>
        </div>
    );
}

export default ShiftDraggable;
